import { useState } from "react";

import { useApiClient } from "../../api-client";

interface RequestCard {
  mobileCountryCode: string;
  mobilePhone: string;
  street: string;
  postalCode: string;
  province: string;
  locality: string;
  streetName: string;
  streetNumber: string;
  details: string;
  district?: string;
  birthdate: string;
}

const useRequestCard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { post } = useApiClient();

  const requestCard = async (address: RequestCard) => {
    setIsLoading(true);
    await post("/v2/employees/request-card", address);
    setIsLoading(false);
  };

  return {
    requestCard,
    isLoading,
  };
};

export { useRequestCard };
